module.exports = __webpack_public_path__ + "img/yizhifu.e53940fd.png";